var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-item-editor" }, [
    _c(
      "section",
      { staticClass: "header" },
      [
        _c("AttributeIconPreview", {
          attrs: { attribute: _vm.clone.attribute },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                ("" + _vm.getAttributeValue()).startsWith("akinon_") ||
                  ("" + _vm.getAttributeValue()).startsWith("probel_") ||
                  _vm.Attributes.includes(_vm.getAttributeValue()) ||
                  _vm.SystemAttributeValues.includes(_vm.getAttributeValue())
                  ? _vm.$t("chatbotv2.attr." + _vm.getAttributeValue())
                  : _vm.Entities.includes(_vm.getAttributeValue())
                  ? _vm.$t("chatbotv2." + _vm.getAttributeValue())
                  : _vm.clone.attribute.startsWith("contact_property_")
                  ? _vm.$_.get(
                      _vm.visitorContactAttributes[
                        _vm.clone.attribute.replace("contact_property_", "")
                      ],
                      "label"
                    )
                  : _vm.getAttributeValue()
              ) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "md-button",
          {
            staticClass: "md-icon-button md-mini",
            on: { click: _vm.onClosed },
          },
          [_c("md-icon", [_vm._v("close")])],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "rules-section" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.condition"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rules" },
        _vm._l(_vm.getOperators(), function (rule) {
          return _c(
            "div",
            {
              key: rule.value,
              staticClass: "rule",
              class: { active: rule.value === _vm.clone.rule },
              on: {
                click: function () {
                  return _vm.changeRule(rule.value)
                },
              },
            },
            [
              rule.value === "equal"
                ? _c("font-awesome-icon", { attrs: { icon: "equals" } })
                : rule.value === "not_equal"
                ? _c("font-awesome-icon", { attrs: { icon: "not-equal" } })
                : rule.value === "less_than"
                ? _c("font-awesome-icon", { attrs: { icon: "less-than" } })
                : rule.value === "less_or_equal"
                ? _c("font-awesome-icon", {
                    attrs: { icon: "less-than-equal" },
                  })
                : rule.value === "greater_than"
                ? _c("font-awesome-icon", { attrs: { icon: "greater-than" } })
                : rule.value === "greater_or_equal"
                ? _c("font-awesome-icon", {
                    attrs: { icon: "greater-than-equal" },
                  })
                : _vm._e(),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("chatbotv2.filters." + rule.value)) +
                  "\n            "
              ),
            ],
            1
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.clone.attribute === "available_agents"
      ? _c("section", { staticClass: "value-section" }, [
          _c("div", { staticClass: "title" }, [_vm._v("Department")]),
          _vm._v(" "),
          _c(
            "span",
            [
              _c(
                "a-select",
                {
                  staticClass: "select-department",
                  attrs: {
                    value: _vm.clone["departmentId"],
                    name: "department",
                  },
                  on: { change: _vm.changeDepartmentId },
                },
                [
                  _c("a-select-option", { key: "all", attrs: { value: "" } }, [
                    _vm._v(" All "),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.subjects, function (department) {
                    return _c(
                      "a-select-option",
                      { key: department._id, attrs: { value: department._id } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getDepartmentTitle(department)) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.attribute === "channelId" &&
    !["empty", "non_empty"].includes(_vm.clone.rule)
      ? _c("section", { staticClass: "value-section" }, [
          _c("div", { staticClass: "title" }, [_vm._v("Channel")]),
          _vm._v(" "),
          _c(
            "span",
            [
              _c(
                "a-select",
                {
                  staticClass: "select-channel",
                  attrs: { value: _vm.clone.value },
                  on: {
                    change: function (e) {
                      return (_vm.clone.value = e)
                    },
                  },
                },
                _vm._l(_vm.channels, function (channel) {
                  return _c(
                    "a-select-option",
                    { key: channel._id, attrs: { value: channel._id } },
                    [_vm._v(_vm._s(channel.name) + "\n                ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ])
      : _vm.clone.attribute === "segments" && _vm.clone.rule !== "empty"
      ? _c(
          "section",
          { staticClass: "value-section" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("Value")]),
            _vm._v(" "),
            _c("SegmentPicker", {
              on: { input: _vm.changeSegmentId },
              model: {
                value: _vm.clone.value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "value", $$v)
                },
                expression: "clone.value",
              },
            }),
          ],
          1
        )
      : _vm.clone.attribute === "tags" && _vm.clone.rule !== "empty"
      ? _c(
          "section",
          { staticClass: "value-section" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("Value")]),
            _vm._v(" "),
            _c("TagPicker", {
              model: {
                value: _vm.clone.value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "value", $$v)
                },
                expression: "clone.value",
              },
            }),
          ],
          1
        )
      : !["empty", "non_empty"].includes(_vm.clone.rule)
      ? _c(
          "section",
          { staticClass: "value-section" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.value"))),
            ]),
            _vm._v(" "),
            _vm.isNumericAttribute()
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.clone.value,
                      expression: "clone.value",
                    },
                  ],
                  class: {
                    error: _vm.isValueValid(),
                    focused: _vm.inputFocused,
                  },
                  attrs: {
                    required: "required",
                    type: "number",
                    placeholder: "Value",
                    min: -9007199254740991,
                    max: 9007199254740991,
                    step: 1,
                  },
                  domProps: { value: _vm.clone.value },
                  on: {
                    focus: function ($event) {
                      _vm.inputFocused = true
                    },
                    blue: function ($event) {
                      _vm.inputFocused = false
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.clone, "value", $event.target.value)
                    },
                  },
                })
              : _vm.isBoolean()
              ? _c(
                  "span",
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "select-attribute",
                        attrs: { value: _vm.clone.value + "" },
                        on: {
                          change: function (e) {
                            _vm.clone.value = e
                          },
                        },
                      },
                      _vm._l(_vm.getBooleanValues(), function (booleanValue) {
                        return _c(
                          "a-select-option",
                          {
                            key: booleanValue.label + "-" + booleanValue.value,
                            attrs: { value: booleanValue.value + "" },
                          },
                          [
                            _vm._v(
                              _vm._s(booleanValue.label) + "\n                "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm.isSelect()
              ? _c(
                  "span",
                  [
                    _c(
                      "a-select",
                      {
                        staticClass: "select-attribute",
                        attrs: { value: _vm.clone.value },
                        on: {
                          change: function (e) {
                            _vm.clone.value = e
                          },
                        },
                      },
                      _vm._l(_vm.getOptions(), function (opt) {
                        return _c(
                          "a-select-option",
                          { key: opt.value, attrs: { value: opt.value } },
                          [_vm._v(_vm._s(opt.label) + "\n                ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm.clone.attribute === "akinon_order_status"
              ? _c(
                  "a-select",
                  {
                    staticClass: "select-akinon",
                    attrs: { value: _vm.clone.value },
                    on: {
                      change: function (e) {
                        return (_vm.clone.value = e)
                      },
                    },
                  },
                  _vm._l(
                    Object.keys(_vm.AKINON_ORDER_STATUSES).map(function (x) {
                      return _vm.AKINON_ORDER_STATUSES[x]
                    }),
                    function (status) {
                      return _c(
                        "a-select-option",
                        { key: status, attrs: { value: status } },
                        [_vm._v(_vm._s(status) + "\n            ")]
                      )
                    }
                  ),
                  1
                )
              : _vm.clone.attribute === "ideasoft_order_status"
              ? _c(
                  "a-select",
                  {
                    staticClass: "select-akinon",
                    attrs: { value: _vm.clone.value },
                    on: {
                      change: function (e) {
                        return (_vm.clone.value = e)
                      },
                    },
                  },
                  _vm._l(
                    Object.keys(_vm.IDEASOFT_ORDER_STATUSES),
                    function (key) {
                      return _c(
                        "a-select-option",
                        { key: key, attrs: { value: key.toLowerCase() } },
                        [
                          _vm._v(
                            _vm._s(_vm.IDEASOFT_ORDER_STATUSES[key]) +
                              "\n            "
                          ),
                        ]
                      )
                    }
                  ),
                  1
                )
              : _vm.clone.attribute === "department"
              ? _c(
                  "a-select",
                  {
                    staticClass: "select-department",
                    attrs: { value: _vm.clone.value },
                    on: {
                      change: function (e) {
                        return (_vm.clone.value = e)
                      },
                    },
                  },
                  _vm._l(_vm.subjects, function (department) {
                    return _c(
                      "a-select-option",
                      { key: department._id, attrs: { value: department._id } },
                      [
                        _vm._v(
                          _vm._s(_vm.getDepartmentTitle(department)) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm.clone.attribute === "channelId"
              ? _c(
                  "a-select",
                  {
                    staticClass: "select-channel",
                    attrs: { value: _vm.clone.value },
                    on: {
                      change: function (e) {
                        return (_vm.clone.value = e)
                      },
                    },
                  },
                  _vm._l(_vm.channels, function (channel) {
                    return _c(
                      "a-select-option",
                      { key: channel._id, attrs: { value: channel._id } },
                      [_vm._v(_vm._s(channel.name) + "\n            ")]
                    )
                  }),
                  1
                )
              : _vm.clone.attribute === "owner"
              ? _c(
                  "a-select",
                  {
                    staticClass: "select-channel",
                    attrs: { value: _vm.clone.value },
                    on: {
                      change: function (e) {
                        return (_vm.clone.value = e)
                      },
                    },
                  },
                  _vm._l(_vm.users, function (user) {
                    return _c(
                      "a-select-option",
                      { key: user._id, attrs: { value: user._id } },
                      [_vm._v(_vm._s(user.name) + "\n            ")]
                    )
                  }),
                  1
                )
              : _vm.clone.attribute === "visitor_trigger_type"
              ? _c(
                  "a-select",
                  {
                    staticClass: "select-channel",
                    attrs: { value: _vm.clone.value },
                    on: {
                      change: function (e) {
                        return (_vm.clone.value = e)
                      },
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { key: "automation", attrs: { value: "automation" } },
                      [_vm._v("Automation")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { key: "broadcast", attrs: { value: "broadcast" } },
                      [_vm._v("Broadcast")]
                    ),
                  ],
                  1
                )
              : _vm.isSelectableContactProperty()
              ? _c(
                  "a-select",
                  {
                    staticClass: "select-channel",
                    attrs: { value: _vm.clone.value },
                    on: {
                      change: function (e) {
                        return (_vm.clone.value = e)
                      },
                    },
                  },
                  _vm._l(_vm.getPropertyList(), function (option) {
                    return _c(
                      "a-select-option",
                      { key: option, attrs: { value: option } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(option) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _c("TiptapEditor", {
                  attrs: {
                    "show-emoji": true,
                    "show-attributes": true,
                    placeholder: _vm.$t("chatbotv2.value"),
                    classNames: [
                      _vm.isValueValid() && "error",
                      _vm.inputFocused && "focused",
                    ].join(" "),
                    "max-character-count": 6200,
                  },
                  on: {
                    focus: function ($event) {
                      _vm.inputFocused = true
                    },
                    blue: function ($event) {
                      _vm.inputFocused = false
                    },
                  },
                  model: {
                    value: _vm.clone.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "value", $$v)
                    },
                    expression: "clone.value",
                  },
                }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "apply" },
      [
        _c(
          "a-button",
          {
            attrs: {
              type: "primary",
              disabled:
                !["empty", "non_empty"].includes(_vm.clone.rule) &&
                _vm.isValueValid(),
            },
            on: { click: _vm.submit },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("chatbotv2.applyFilter")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }